import React from "react";
import DevicesTable from "./DevicesTable";

const AllDevices = () => {
  return <DevicesTable status="all" />;
};

export default AllDevices;
